import { render } from "./Voucher.vue?vue&type=template&id=04d928b0&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"

import "./Voucher.vue?vue&type=style&index=0&id=04d928b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d928b0"]])

export default __exports__